import PropTypes from 'prop-types';

import {
  BaseDefaultProps,
  BasePropTypes,
} from '@/common/proptypes/Base/Base.proptypes';

export const RelatedProductsDefaultProps = {
  ...BaseDefaultProps,
  id: null,
  related: [],
  title: null,
};

export const RelatedProductsPropTypes = {
  ...BasePropTypes,
  id: PropTypes.string,
  related: PropTypes.arrayOf(PropTypes.shape({})),
  title: PropTypes.string,
};
